/**
 * RTWO Asset & Token Engine — Null Cryptography Adapter
 */

import type { AssetId } from '../domain-models';
import type {
  ICryptographyAdapter,
  CryptographyAdapterStatus,
} from './cryptography-adapter-interface';

export class NullCryptographyAdapter implements ICryptographyAdapter {
  readonly adapterId = 'null-cryptography-adapter';
  readonly adapterName = 'Null Cryptography Adapter';

  async connect(): Promise<void> {}

  async disconnect(): Promise<void> {}

  getStatus(): CryptographyAdapterStatus {
    return 'not_configured';
  }

  isReady(): boolean {
    return false;
  }

  async grantPermission(_assetId: AssetId, _permissionType: string, _subjectReference: string) {
    return null;
  }
}
